import React, { Component } from "react";
import {Link} from "react-router-dom";
import Select from "react-select";
import DatePicker from 'react-date-picker';
import './NewCollection.scss';
import MyContext from '../MyContext.jsx';
import {epochToDate} from '../../assets/js/handy.mjs';

class NewCollection extends Component {
  constructor(props) {
    super(props);
    this.dealerSelect = React.createRef();
    this.paymentModeSelect = React.createRef();
    this.bankSelect = React.createRef();
    this.branchSelect = React.createRef();
    this.state = {
      collection_id : '',
      dealers : [],
      dealer : '',
      bills : [],
      selected_bills : [],
      banks : [],
      bank :  '',
      payment_modes : [],
      payment_mode : '',
      branches : [],
      branch : {},
      amount : '',
      currency_type : '',
      receipt_no : '',
      other : '',
      cheque_no : '',
      cheque_date : '',
      reference_id : '',
      transaction_date : ''
    }
    this.formChange = this.formChange.bind(this);
    this.billChange = this.billChange.bind(this);
    this.goBackButton = this.goBackButton.bind(this);
   

  }

  componentDidMount(){   
    $(".react-date-picker__inputGroup input").attr("readonly","true");
    var obj_this = this;
    const {pathname} = this.props.location;
    if(pathname === "/collections/new") {
      const url = `${process.env.REACT_APP_SSS}/api/getCollectionDetails`;
      this.context.loading(1);
      let customer_id;
      const { location } = this.props;
      if (location.state && location.state.customer_id) {
        this.setState({ customer_id: location.state.customer_id });
        customer_id = location.state.customer_id;
      }
      $.ajax({
        url : url,
        data : {
          sid : this.context.user_details.sid
        },
        type : "POST"
      }).done(function(return_data){
        console.log(return_data);
        // return;
        if(return_data.status == "success"){
          obj_this.setState({
            dealers : return_data.dealers,
            banks : return_data.banks,
            payment_modes : return_data.payment_modes,
            currency_type : return_data.currency_type
          });
          obj_this.context.loading(0);
          let option = null;
          if(customer_id && return_data.dealers){
            option = return_data.dealers.find(item => item.value === customer_id);
            
            if(option){
              obj_this.dealerChange(option);
              obj_this.setState({
                dealer : option,
              })
            }
             
          }
        }else{
          obj_this.context.loading(0);
          obj_this.props.history.replace("/");
        }
      }).fail(function(){
        alert("Network error");
      });
    }else{
      const collection_id = this.props.match.params.coll_id;
      const url = `${process.env.REACT_APP_SSS}/api/editCollectionDetails`;
      this.context.loading(1);
      $.ajax({
        url : url,
        data : {
          collection_id : collection_id,
          sid : this.context.user_details.sid
        },
        type : "POST"
      }).done(function(return_data){
        console.log(return_data);
        // return;
        if(return_data.status == "success"){
          var state_object = return_data.state_object;
          state_object.cheque_date = epochToDate(state_object.cheque_date);
          state_object.transaction_date = epochToDate(state_object.transaction_date);
          obj_this.setState(return_data.state_object);
          obj_this.context.loading(0);
        }else{
          obj_this.context.loading(0);
          obj_this.props.history.replace("/");
        }
      }).fail(function(){
        alert("Network error");
      });
    }
  }

  formChange(e){
    this.setState({
      [e.target.name] : e.target.value
    });
  }

  dealerChange(option){
    var obj_this = this;
    const url = `${process.env.REACT_APP_SSS}/api/getDealerBills`;
    this.context.loading(1);
    $.ajax({
      url : url,
      data : {
        customer_id : option.value,
        sid : this.context.user_details.sid
      },
      type : "POST"
    }).done(function(return_data){
      console.log(return_data);
      // return;
      if(return_data.status == "success"){
        obj_this.setState({
          bills : return_data.bills,
          dealer : option,
          selected_bills : []
        });
        obj_this.context.loading(0);
      }else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
     }).fail(function(){
      alert("Network error");
      obj_this.context.loading(0);
      obj_this.props.history.replace("/");
    });
  }

  billChange(value) {
    // return (this.state.country.map(data => ({ label: data.Name, value: data.Id }))) 
    this.setState({
      selected_bills: value,
    });
  }

  paymentModeChange(option){
    if(option.label == "CASH"){
      this.setState({
        bank :  '',
        branch : '',
        other : '',
        cheque_no : '',
        cheque_date : '',
        reference_id : '',
        transaction_date : ''
      });
    }else if(option.label == "CHEQUE"){
      this.setState({
        reference_id : '',
        transaction_date : ''
      });
    }else{
      this.setState({
        cheque_no : '',
        cheque_date : '',
      });
    }
    this.setState({
      payment_mode : option
    });
  }

  bankChange(option){
    var obj_this = this;
    const url = `${process.env.REACT_APP_SSS}/api/getBankBranches`;
    this.context.loading(1);
    $.ajax({
      url : url,
      data : {
        bank_id : option.value,
        sid : this.context.user_details.sid
      },
      type : "POST"
    }).done(function(return_data){
      console.log(return_data);
      // return;
      if(return_data.status == "success"){
        obj_this.setState({
          branches : return_data.branches,
          bank : option,
          other : ''
        });
        obj_this.context.loading(0);
      }else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
     }).fail(function(){
      alert("Network error");
      obj_this.context.loading(0);
      obj_this.props.history.replace("/");
    });
  }

  branchChange(option){
    this.setState({
      branch : option
    });
  }

  onChequeDateChange(value){
    this.setState({cheque_date : value});
  }

  onTransactionDateChange(value){
    this.setState({transaction_date : value});
  }

  formSubmit(e){
    e.preventDefault();
    const { history, location } = this.props;

    // console.log(this.state);
    var collection_details = this.state;
    if(!collection_details.dealer.value){
       this.dealerSelect.current.focus();
      return;
    }
    if(!collection_details.payment_mode.value){
       this.paymentModeSelect.current.focus();
      return;
    }
    if(collection_details.payment_mode.label != "CASH" && !collection_details.bank.value){
       this.bankSelect.current.focus();
      return;
    }
    // if(collection_details.payment_mode.label != "CASH" && !collection_details.other && !collection_details.branch.value){
    //    this.branchSelect.current.focus();
    //   return;
    // }
    delete collection_details.dealers;
    collection_details.cheq_date = collection_details.cheque_date.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' });
    collection_details.trans_date = collection_details.transaction_date.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' });
    // console.log(this.state);
    // return;
    collection_details.schedule_id = location.state?.schedule_id??null;
    const url = `${process.env.REACT_APP_SSS}/api/saveCollectionDetails`;
    this.context.loading(1);
    var obj_this = this;
    $.ajax({
      url : url,
      data : {
        sid : this.context.user_details.sid,
        collection_details : collection_details
      },
      type : "POST"
    }).done(function(return_data){
      console.log(return_data);
      // return;
      if(return_data.status == "create"){
        alert("Collection inserted.");
        // obj_this.context.loading(0);
        // obj_this.props.history.replace('/collections');
        if (location.state && location.state.from == "schedule") {
          history.push("/schedules/details/edit/"+location.state.schedule_id, { from : "collection", collectionData: collection_details, purposeOfVisit : location.state.purposeOfVisit });
        } else {
          // Redirect to the previous page if it was called directly
          history.goBack();
        }
      }else if(return_data.status == "update"){
        alert("Collection updated.");
        obj_this.context.loading(0);
        if (location.state && location.state.from == "schedule") {
          history.push("/schedules/details/edit/"+location.state.schedule_id, { from : "collection", collectionData: collection_details, purposeOfVisit : location.state.purposeOfVisit });
        } else {
          // Redirect to the previous page if it was called directly
          history.goBack();
        }
      }else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
     }).fail(function(){
      alert("Network error");
      obj_this.context.loading(0);
      obj_this.props.history.replace("/");
    });
  }
  goBackButton(e){
    e.preventDefault();

    const { history, location } = this.props;

    if (location.state && location.state.from == "schedule") {
      history.push("/schedules/details/edit/"+location.state.schedule_id, { from : "collection",purposeOfVisit : location.state.purposeOfVisit });
    } else {
      // Redirect to the previous page if it was called directly
      history.goBack();
    }
  }

  render(){

  return (
    <MyContext.Consumer>
      {context => (
        <div className="new_collection_container">
          <div className="page_header">
            {/* <span className="back_button" onClick={e=>this.goBackButton(e)}><i className="fas fa-arrow-left"></i></span> */}
            <div className="page_title"><i className="fas fa-arrow-left" onClick={() => window.history.back()} style={{marginRight: '15px', cursor: 'pointer'}}></i> {this.state.collection_id?"Edit":"New"} Collection</div>
          </div> 
          <form className="enquiry_form"
            onSubmit={e => this.formSubmit(e)}
          >
            <div className="collection_details_container blocks">
              <div className="input_label">Customer</div>
              <Select 
                options={this.state.dealers}  
                value ={this.state.dealer}
                className="dealer" 
                ref={this.dealerSelect}
                onChange={e => this.dealerChange(e)}
                required
              />
              <div className="input_label">Invoice(S)</div>
              <Select 
                options={this.state.bills}  
                value ={this.state.selected_bills}
                className="bills" 
                isMulti={true}
                ref={this.billSelect}
                onChange={this.billChange}
                required
              />   
              <div className="input_grid">
                <div>
                  <div className="input_label">Amount({this.state.currency})</div>
                  <input className="amount input custom_input"
                    type="number"
                    name="amount"
                    value={this.state.amount}
                    onChange={this.formChange}
                    required
                    autoComplete="off"
                  />
                </div>
                <div>
                  <div className="input_label">Receipt No</div>
                  <input className="receipt_no input custom_input"
                    type="text"
                    name="receipt_no"
                    value={this.state.receipt_no}
                    onChange={this.formChange}
                    disabled
                    autoComplete="off"
                  />
                </div>
              </div> 

              <div className="input_label">Mode of Payment</div>
              <Select 
                options={this.state.payment_modes}  
                value ={this.state.payment_mode}
                className="payment_mode" 
                ref={this.paymentModeSelect}
                onChange={e => this.paymentModeChange(e)}
                required
              />  
              <div style={{display:this.state.payment_mode.label == "CASH"?"none":"block"}}>
                <div className="input_label">Bank</div>
                <Select 
                  style={{display:this.state.payment_mode.label == "CASH"?"none":"block"}}
                  options={this.state.banks}  
                  value ={this.state.bank}
                  className="bank" 
                  ref={this.bankSelect}
                  onChange={e => this.bankChange(e)}
                  required
                />  
              </div>
              <div className="input_grid" 
                style={{display:this.state.payment_mode.label == "CASH"?"none":"grid"}}
              >
                <div>
                  <div className="input_label">Branch</div>
                  <Select 
                    options={this.state.branches}  
                    value ={this.state.branch}
                    className="branch" 
                    ref={this.branchSelect}
                    onChange={e => this.branchChange(e)}
                  />  
                </div>
                <div>
                  <div className="input_label">Other</div>
                  <input className="other input custom_input"
                    type="text"
                    name="other"
                    value={this.state.other}
                    onChange={this.formChange}
                    autoComplete="off"
                  />
                </div>
              </div>   
              <div style={{display:this.state.payment_mode.label == "CASH"?"none":this.state.payment_mode.label == "CHEQUE"?"block":"none"}}>
                <div className="input_label">Cheque No</div>
                <input className="cheque_no input custom_input"
                  type="text"
                  name="cheque_no"
                  value={this.state.cheque_no}
                  onChange={this.formChange}
                  required={this.state.payment_mode.label=="CHEQUE"}
                  autoComplete="off"
                />
              </div>
              <div style={{display:this.state.payment_mode.label == "CASH"?"none":this.state.payment_mode.label == "CHEQUE"?"block":"none"}}>
                <div className="input_label">Cheque Date</div>
                <DatePicker
                  className="input custom_input cheque_date"
                  onChange={(value) => this.onChequeDateChange(value)}
                  value={this.state.cheque_date}
                  format="dd-MM-y"
                  minDate = {new Date()}
                  required={this.state.payment_mode.label=="CHEQUE"}
                /> 
              </div> 
              <div style={{display:this.state.payment_mode.label == "CASH"?"none":this.state.payment_mode.label != "CHEQUE"?"block":"none"}}>
                <div className="input_label">Reference ID</div>
                <input className="reference_id input custom_input"
                  type="text"
                  name="reference_id"
                  value={this.state.reference_id}
                  onChange={this.formChange}
                  required={(this.state.payment_mode.label =="CASH" || this.state.payment_mode.label =="CHEQUE")?false:true}
                  autoComplete="off"
                />
              </div>
              <div style={{display:this.state.payment_mode.label == "CASH"?"none":this.state.payment_mode.label != "CHEQUE"?"block":"none"}}>
                <div className="input_label">Transaction Date</div>
                <DatePicker
                  className="input custom_input transaction_date"
                  onChange={(value) => this.onTransactionDateChange(value)}
                  value={this.state.transaction_date}
                  format="dd-MM-y"
                  minDate = {new Date()}
                  required={(this.state.payment_mode.label =="CASH" || this.state.payment_mode.label =="CHEQUE")?false:true}
                />  
              </div>
              
            </div>

            <button type="submit" className="submit_button"><i className="far fa-save"></i> Save</button>
          </form>           
        </div>
      )}
    </MyContext.Consumer>
  )}
}

export default NewCollection;
NewCollection.contextType = MyContext;
